/**
 * Created by renlaydel on 02/11/2017.
 */

/* eslint-disable no-restricted-globals */

import keyBy from 'lodash/keyBy';
import { delay, takeEvery, takeLatest, select, call, put } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import { change, arrayRemove, arraySplice, formValueSelector } from 'redux-form';
import uuid from 'uuid/v4';

import * as sagaCommon from '../../sagasCommon';
import * as sagaCommonUtils from '../../sagas_utils/sagas_common_utils';
import * as apiCommon from '../../../services/apiCommon';
import * as apiTaxCode from '../../../services/tax/apiTaxCode';
import * as apiExchangeRate from '../../../services/exchange_rate/api_exchange_rate';
import * as apiPurchaseOrder from '../../../services/purchase/order/api_purchase_order';
import * as apiPurchaseCommon from '../../../services/purchase/common/api_purchase';
import * as sagaPurchaseReceipt from '../../../sagas/purchase/receipt/sagas_purchase_receipt';
import * as utilityPreference from '../../../services/preference/utilty_preference';
import * as helperInventory from '../../../services/inventory/helper_inventory';
import {
  getFormLines,
  isExistingOrder,
  isViewMode,
} from '../../../components/admin/purchase/order/PurchaseOrderSelector';
import { updateAvailableOnHand } from '../saga_purchase';
import * as actions from '../../../actions/actionCreatorsPurchase';
import * as ts from '../../../constants/constant_transaction_status';
import * as cv from '../../../constants/constant_values';

import {
  GET_PURCHASE_ORDER,
  GET_PURCHASE_ORDER_REORDER,
  SAVE_PURCHASE_ORDER,
  FETCH_LIST_PURCHASE_ORDER,
  GET_ALL_PURCHASE_ORDER_LINES_ITEM_LOCATION,
  GET_PURCHASE_ORDER_LINE_ITEM_LOCATION,
  GENERATE_PURCHASE_RECEIPT_DATA,
  GET_PURCHASE_ORDER_EXCHANGE_RATE,
  GET_PURCHASE_ORDER_LINE_TAX_GROUP,
} from '../../../constants/constant_saga_types';
import { PURCHASE_ORDER } from '../../../constants/constant_doc_types';
import { GENERATE_PURCHASE_RECEIPT } from '../../../constants/constant_action_types';
import { PurchaseOrderForm } from '../../../constants/constant_form_names';
import { getOpenTransactionStatus } from '../../../common/selectors/selector_common';
import { getParticularPreferenceSettings } from '../../../common/selectors/preference';
import { hasLines } from '../../../components/admin/purchase/order/PurchaseOrderSelector';

export function* getPurchaseOrderSaga(feathersApp) {
  yield takeEvery(GET_PURCHASE_ORDER, callGetPurchaseOrder, feathersApp);
}

export function* callGetPurchaseOrder(feathersApp, action) {
  try {
    const { user } = yield select();
    const { id } = action;
    yield sagaCommon.showProgressDataById();

    if (id) {
      const data = yield call(
        apiPurchaseOrder.fetchPurchaseOrderById,
        feathersApp,
        { id, user },
      );
      yield sagaCommon.doneDataById(data);

      if (data.status.cid === ts.OPEN) {
        yield put(actions.getAllPurchaseOrderLinesItemLocation(data.location_id));
      }
    } else {
      const openTransactionStatus = yield select(getOpenTransactionStatus);
      const primaryContactNumber = (user.contact_numbers || []).find(
        number => number.primary,
      );
      const data = {
        status_id: openTransactionStatus.id,
        status: openTransactionStatus,
        exchange_rate: 1,
        purchase_contact_id: user.id,
        purchase_contact_email: user.email,
        purchase_contact_number: (primaryContactNumber || {}).value,
      };

      yield sagaCommon.doneDataById(data);
    }
  } catch (e) {
    yield sagaCommon.showErrorDataById(e, true);
  }
}

export function* savePurchaseOrderSaga(feathersApp) {
  yield takeLatest(SAVE_PURCHASE_ORDER, callSavePurchaseOrder, feathersApp);
}

export function* callSavePurchaseOrder(feathersApp, action) {
  try {
    const { user } = yield select();
    const isView = yield select(isViewMode);
    const { data, redirectToView } = action;
    const { location_id, lines, supplier_id } = data;
    const itemIds = [];
    let supplierUnavailable = false;
    lines.forEach(({ item_id, item_location }) => {
      if (
        ((item_location || {}).supplier_ids || []).indexOf(supplier_id) < 0
        && !isView
      ) {
        supplierUnavailable = true;
      }

      itemIds.push(item_id);
    });

    if (supplierUnavailable) {
      const okSupplier = confirm(
        'Items selected does not have the identified supplier. Do you want to proceed?',
      );
      if (!okSupplier) {
        return;
      }
    }

    const purchaseOrderId = data.id;
    const locationId = location_id;
    const existingPurchaseOrders = yield call(
      apiPurchaseOrder.getExistingPurchaseOrder,
      feathersApp,
      { itemIds, locationId, purchaseOrderId },
    );

    if (existingPurchaseOrders.length) {
      const ok = confirm(
        'Found open purchase orders related to the items below. Do you want to proceed?',
      );
      if (!ok) {
        return;
      }
    }

    yield sagaCommon.showProgressSaveRecord();

    let result = yield call(apiPurchaseOrder.savePurchaseOrder, feathersApp, {
      user,
      data,
    });
    const id = result.id;

    yield put({ type: GET_PURCHASE_ORDER, id });

    if (redirectToView) {
      browserHistory.push(`/admin/purchase/order/view/${id}`);
    } else {
      browserHistory.push(`/admin/purchase/order/edit/${id}`);
    }

    yield sagaCommon.doneSaveRecord(result, 'Purchase order was saved');
  } catch (e) {
    console.error(e.stack);
    yield sagaCommon.showErrorSaveRecord(e);
  }
}

export function* fetchListPurchaseOrderSaga(feathersApp) {
  yield takeLatest(
    FETCH_LIST_PURCHASE_ORDER,
    callFetchListPurchaseOrder,
    feathersApp,
  );
}

export function* callFetchListPurchaseOrder(feathersApp, action) {
  try {
    yield delay(250);
    const { silent, filters } = action;
    yield sagaCommon.showProgressListTable(silent);
    const dataParams = {
      filters,
      list_type: 'purchase_order',
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(sagaCommon.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (e) {
    yield sagaCommon.showErrorListTable(e);
  }
}

export function* getAllPurchaseOrderLinesItemLocationSaga(feathersApp) {
  yield takeLatest(
    GET_ALL_PURCHASE_ORDER_LINES_ITEM_LOCATION,
    callGetAllPurchaseOrderLinesItemLocation,
    feathersApp,
  );
}

export function* callGetAllPurchaseOrderLinesItemLocation(feathersApp, action) {
  try {
    const { tenant, intl } = yield select();
    const lines = yield select(getFormLines);
    const isExisting = yield select(isExistingOrder);
    const isView = yield select(isViewMode);
    const { locationId } = action;

    const itemLocationsQuery = lines.map(({ item_id }) => ({
      item_id: item_id.split(':')[0],
      location_id: locationId,
    }));
    const itemLocations = yield call(
      apiPurchaseCommon.getItemLocations,
      feathersApp,
      itemLocationsQuery,
    );
    const indexedItemLocations = keyBy(
      itemLocations,
      itemLocation => `${itemLocation.item_id}:${itemLocation.location_id}`,
    );

    let validItemLocations = true;

    const newLines = [];

    for (let line of lines) {
      const index = `${line.item_id.split(':')[0]}:${locationId}`;
      const itemLocation = indexedItemLocations[index];

      if (isExisting && !isView && itemLocation) {
        newLines.push({
          ...line,
          item_location: itemLocation,
        });
      } else if (itemLocation) {
        const taxGroup = itemLocation.tax_group || {};
        const taxCodes = yield call(
          apiTaxCode.getApplicableTaxByTaxGroupId,
          feathersApp,
          taxGroup.id,
        );
        const taxRate = yield call(apiTaxCode.calculateTotalTaxRate, taxCodes);
        const minReorderPoint = itemLocation.min_reorder_point || 0;
        const maxReorderPoint = itemLocation.max_reorder_point || 0;
        const backOrderQty = itemLocation.back_order_quantity || 0;
        const onHand = itemLocation.on_hand || 0;
        const safetyStock = itemLocation.safety_stock || 0;

        const params = yield call(
          utilityPreference.buildPreferenceQueryFromItemLocation,
          itemLocation,
          ['include_backorder'],
          tenant,
        );
        const settings = yield call(
          utilityPreference.getPreferenceValues,
          feathersApp,
          {
            ...params,
            intl,
          },
        );
        const available = helperInventory.calculateQuantityAvailable(
          itemLocation,
          settings,
        );

        let reorderQty = 0;
        if (available < minReorderPoint) {
          const suggestedReorderQty =
            Math.max(maxReorderPoint, safetyStock) - onHand - backOrderQty;
          if (suggestedReorderQty > 0) {
            reorderQty = suggestedReorderQty;
          }
        }

        const lineUnitCost = (yield select(
          getParticularPreferenceSettings,
          'po_line_unit_cost',
          ['value'],
        )).value;
        const averageCost = itemLocation.average_cost || 0;
        const purchaseCost = itemLocation.purchase_cost || 0;
        const displayPurchaseCost = lineUnitCost === cv.PURCHASE_COST;
        const unitCost = displayPurchaseCost ? purchaseCost : averageCost;

        const updatedTaxGroup = (taxCodes || []).length
          ? taxCodes[0].tax_group
          : taxGroup;
        const newLine = {
          ...line,
          available_pre_order: available,
          tax_group: updatedTaxGroup,
          tax_group_id: updatedTaxGroup.id,
          tax_rate: taxRate,
          total: 0,
          quantity: reorderQty > 0 ? reorderQty : 0,
          suggested_reorder_quantity: reorderQty,
          unit_cost: unitCost,
          unit_price_location: 0,
          item_location: itemLocation,
        };
        if (newLine.item_uom) {
          newLine.uom_unit_cost = unitCost * newLine.item_uom.conversion_rate;
        }
        newLines.push(newLine);
      } else {
        validItemLocations = false;
      }
    }

    yield put(change(PurchaseOrderForm, 'lines', newLines));

    if (!validItemLocations) {
      throw new Error('Item is not available in location');
    }
  } catch (e) {
    console.error('@callGetAllPurchaseOrderLinesItemLocation: e', e);
    yield sagaCommon.showErrorSaveRecord(e);
  }
}

export function* getPurchaseOrderLineItemLocationSaga(feathersApp) {
  yield takeEvery(
    GET_PURCHASE_ORDER_LINE_ITEM_LOCATION,
    callGetPurchaseOrderLineItemLocation,
    feathersApp,
  );
}

export function* callGetPurchaseOrderLineItemLocation(feathersApp, action) {
  try {
    const { tenant, intl, purchase } = yield select();
    const { locationId, itemId, index, itemUom, skipCheck } = action;
    const { order } = purchase;
    const { data } = order;
    const purchaseOrderId = data.id;
    const existingPurchaseOrders = yield call(
      apiPurchaseOrder.getExistingPurchaseOrder,
      feathersApp,
      { itemId: itemId.split(':')[0], locationId, purchaseOrderId },
    );

    if (existingPurchaseOrders.length) {
      const ok = skipCheck || confirm(
        'Found open purchase orders for this item. Do you want to proceed?',
      );

      if (!ok) {
        yield call(resetLine, index);

        return;
      }
    }

    yield put(
      change(PurchaseOrderForm, `lines[${index}].isFetchingItemLocation`, true),
    );

    const itemLocation = yield call(
      apiPurchaseCommon.getItemLocation,
      feathersApp,
      {
        itemId: itemId.split(':')[0],
        locationId,
      },
    );

    if (itemLocation) {
      const taxGroup = itemLocation.tax_group || {};
      const taxCodes = yield call(
        apiTaxCode.getApplicableTaxByTaxGroupId,
        feathersApp,
        taxGroup.id,
      );
      const taxRate = yield call(apiTaxCode.calculateTotalTaxRate, taxCodes);
      const minReorderPoint = Number(itemLocation.min_reorder_point) || 0;
      const maxReorderPoint = Number(itemLocation.max_reorder_point) || 0;
      const backOrderQty = Number(itemLocation.back_order_quantity) || 0;
      const onHand = Number(itemLocation.on_hand) || 0;
      const safetyStock = Number(itemLocation.safety_stock) || 0;

      const params = yield call(
        utilityPreference.buildPreferenceQueryFromItemLocation,
        itemLocation,
        ['include_backorder'],
        tenant,
      );
      const preference = yield call(
        utilityPreference.getPreferenceValues,
        feathersApp,
        {
          ...params,
          intl,
        },
      );
      const available = helperInventory.calculateQuantityAvailable(
        itemLocation,
        preference,
      );

      let reorderQty = 0;
      if (available < minReorderPoint) {
        const suggestedReorderQty =
          Math.max(maxReorderPoint, safetyStock) - onHand - backOrderQty;

        if (suggestedReorderQty > 0) {
          reorderQty = suggestedReorderQty;
        }
      }

      const lineUnitCost = (yield select(
        getParticularPreferenceSettings,
        'po_line_unit_cost',
        ['value'],
      )).value;
      const averageCost = itemLocation.average_cost || 0;
      const purchaseCost = itemLocation.purchase_cost || 0;
      const displayPurchaseCost = lineUnitCost === cv.PURCHASE_COST;
      const unitCost = displayPurchaseCost ? purchaseCost : averageCost;
      const updatedTaxGroup = (taxCodes || []).length
        ? taxCodes[0].tax_group
        : taxGroup;
      const selector = formValueSelector(PurchaseOrderForm);
      const itemLines = yield select(selector, 'lines');
      const itemLine = itemLines[index];
      if (itemUom) {
        const uomAvailableQty = Math.floor(available/itemUom.conversion_rate);
        itemLine.uom_available_pre_order = Number(uomAvailableQty);
        const uomReorderQty = Math.floor(reorderQty/itemUom.conversion_rate);
        itemLine.uom_quantity = uomReorderQty > 0 ? uomReorderQty : 0;
        itemLine.uom_suggested_reorder_quantity = uomReorderQty;
        itemLine.uom_unit_cost = unitCost * itemUom.conversion_rate;
      }
      itemLine.available_pre_order = available;
      itemLine.tax_group = updatedTaxGroup;
      itemLine.tax_group_id = updatedTaxGroup.id;
      itemLine.tax_rate = taxRate || 0;
      itemLine.total = 0;
      itemLine.quantity = reorderQty > 0 ? reorderQty : 0;
      itemLine.suggested_reorder_quantity = reorderQty;
      itemLine.unit_cost = unitCost;
      itemLine.unit_price_location = 0;
      itemLine.item_location = itemLocation;
      itemLine.isFetchingItemLocation = false;

      yield put(arraySplice(PurchaseOrderForm, 'lines', index, 1, itemLine));
    } else {
      yield call(resetLine, index);

      throw new Error('Item is not available in location');
    }
  } catch (e) {
    yield sagaCommon.showErrorSaveRecord(e);
  }
}

function* resetLine(index) {
  yield put(arrayRemove(PurchaseOrderForm, 'lines', index));
}

export function* getPurchaseOrderLineTaxGroupSaga(feathersApp) {
  yield takeEvery(
    GET_PURCHASE_ORDER_LINE_TAX_GROUP,
    callGetPurchaseOrderLineTaxGroup,
    feathersApp,
  );
}

export function* callGetPurchaseOrderLineTaxGroup(feathersApp, action) {
  try {
    const { taxGroup, index } = action;
    yield put(
      change(PurchaseOrderForm, `lines[${index}].isFetchingTaxGroup`, true),
    );

    const taxCodes = yield call(
      apiTaxCode.getApplicableTaxByTaxGroupId,
      feathersApp,
      taxGroup.id,
    );
    const taxRate = yield call(apiTaxCode.calculateTotalTaxRate, taxCodes);
    const updatedTaxGroup = (taxCodes || []).length
      ? taxCodes[0].tax_group
      : taxGroup;

    yield put(
      change(PurchaseOrderForm, `lines[${index}].tax_group`, updatedTaxGroup),
    );

    yield put(
      change(
        PurchaseOrderForm,
        `lines[${index}].tax_group_id`,
        updatedTaxGroup.id,
      ),
    );
    yield put(
      change(PurchaseOrderForm, `lines[${index}].tax_rate`, taxRate || 0),
    );
    yield put(
      change(PurchaseOrderForm, `lines[${index}].isFetchingTaxGroup`, false),
    );
  } catch (e) {
    yield sagaCommon.showErrorSaveRecord(e);
  }
}

export function* getPurchaseOrderExchangeRateSaga(feathersApp) {
  yield takeLatest(
    GET_PURCHASE_ORDER_EXCHANGE_RATE,
    callGetPurchaseOrderExchangeRate,
    feathersApp,
  );
}

export function* callGetPurchaseOrderExchangeRate(feathersApp, action) {
  try {
    const { currencyFromId, currencyToId, date } = action;
    const exchangeRate = yield call(
      apiExchangeRate.getExchangeRate,
      feathersApp,
      {
        currencyFromId,
        currencyToId,
        date,
      },
    );
    yield put(
      change(
        PurchaseOrderForm,
        'exchange_rate',
        Number((exchangeRate || {}).rate) || 1,
      ),
    );
  } catch (e) {
    yield sagaCommon.showErrorSaveRecord(e);
  }
}

export function* generatePurchaseReceiptSaga(feathersApp) {
  yield takeEvery(
    GENERATE_PURCHASE_RECEIPT_DATA,
    callGeneratePurchaseReceipt,
    feathersApp,
  );
}

export function* callGeneratePurchaseReceipt(feathersApp, action) {
  try {
    const { data, generateReceipt } = action;
    yield put({ type: GENERATE_PURCHASE_RECEIPT, generateReceipt });
    const purchaseReceipt = yield call(
      sagaPurchaseReceipt.buildPurchaseReceipt,
      feathersApp,
      data,
    );
    yield sagaCommon.doneDataById(purchaseReceipt);
  } catch (e) {
    yield sagaCommon.showErrorSaveRecord(e);
  }
}

export function* getPurchaseOrderCopy(feathersApp, action) {
  try {
    const { user } = yield select();
    const { data } = action;

    let lines = data.lines.map(itemLine => ({
      ...itemLine,
      remaining_quantity: 0,
      purchase_order_id: undefined,
      id: undefined,
      _id: undefined,
    }));

    lines = yield updateAvailableOnHand(feathersApp, lines);

    const openTransactionStatus = yield select(getOpenTransactionStatus);
    const primaryContactNumber = (user.contact_numbers || []).find(
      number => number.primary,
    );

    const purchaseOrderCopy = {
      alternate_classification_ids: data.alternate_classification_ids,
      brand_ids: data.brand_ids,
      classification_ids: data.classification_ids,
      currency_id: data.currency_id,
      dispatched_date: data.dispatched_date,
      dispatched_method_id: data.dispatched_method_id,
      doc_type: PURCHASE_ORDER,
      exchange_rate: data.exchange_rate,
      expected_eta: data.expected_eta,
      lines: lines,
      location_id: data.location_id,
      notes: data.notes,
      purchase_contact_email: user.email,
      purchase_contact_id: user.id,
      purchase_contact_number: (primaryContactNumber || {}).value,
      reference_number: data.reference_number,
      sales_order_reference: data.sales_order_reference,
      status: openTransactionStatus,
      status_id: openTransactionStatus.id,
      subsidiary_id: data.subsidiary_id,
      supplier_id: data.supplier_id,
    };

    return purchaseOrderCopy;
  } catch (e) {
    yield sagaCommon.showErrorSaveAsRecord(e);
  }
}

export function* getPurchaseOrderReorderSaga(feathersApp) {
  yield takeEvery(
    GET_PURCHASE_ORDER_REORDER,
    callGetPurchaseOrderReorder,
    feathersApp,
  );
}

export function* callGetPurchaseOrderReorder(feathersApp, action) {
  const prefAutoRefill = (yield select(
    getParticularPreferenceSettings,
    'po_auto_refill',
    ['value'],
  ));
  const prefAutoRefillVal = JSON.parse(prefAutoRefill.value);
  if (!prefAutoRefillVal) return;

  const headerRefill = 'Refill';
  const bodyRefill = 'Refill Supplier Items?';
  const shouldRefill = yield call(
    sagaCommonUtils.promptModal,
    headerRefill,
    bodyRefill,
    false,
  );
  if (!shouldRefill) return;

  const linesExists = yield select(hasLines);
  let shouldClearLines = false;
  if (linesExists) {
    const headerClear = 'Clear Lines';
    const bodyClear = 'There are existsing lines. Do you want to clear lines?';
    const signalClear = yield call(
      sagaCommonUtils.promptModal,
      headerClear,
      bodyClear,
      false,
    );
    shouldClearLines = signalClear;
  }
  if (shouldClearLines) yield put(change(PurchaseOrderForm, 'lines', []));

  const maxPref = (yield select(
    getParticularPreferenceSettings,
    'po_auto_refill_lines',
    ['value'],
  )).value;
  const maxNum = Number(maxPref);
  const { locationId, supplierId } = action;
  const { data: reorders, total } = yield call(
    apiPurchaseOrder.getPurchaseOrderReorder,
    feathersApp,
    locationId,
    supplierId,
    maxNum,
  );
  const totalNum = Number(total);
  const itemLine = {
    onEditMode: false,
    total: 0,
    total_ex_tax: 0,
    unit_cost: 0,
    suggested_reorder_quantity: 0,
  };
  const lines = reorders.map((r) => {
    return {
      ...itemLine,
      item: r.item,
      item_id: r.item_id,
      item_type_id: r.item_type_id,
      line_id: uuid(),
    };
  });

  yield put(change(PurchaseOrderForm, 'lines', lines));

  for (const [i, l] of Object.entries(lines)) {
    const ilId = `${l.item_id}:${locationId}`;
    yield put(actions.getPurchaseOrderLineItemLocation(locationId, ilId, i, l.item_uom));
  }

  if (totalNum > maxNum) {
    const headerLinesReached = 'Refill Lines Reached';
    const bodyLinesReached = 'The maximum auto refill lines has been reached. '
      + 'Additional Purchase Orders can be created for the remaining items.';
    yield call(sagaCommonUtils.promptModal, headerLinesReached, bodyLinesReached);
  }
}
